import React from "react";
import NumberFormat from "react-number-format";
import NullableValue from "../../../../../../../../Utils/renderField/nullableValue";
import { RenderKilogramo } from "../../../../../../../../Utils/renderField/renderReadField";

export const SobrantesTable = ({ existencias, handleChange }) => {
    return (
        <div className="new-table-wrapper mt-3">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Producto</th>
                        <th>Kg disponibles</th>
                        <th>Kg a tomar</th>
                    </tr>
                </thead>
                <tbody>
                    {existencias.length === 0 && (
                        <tr>
                            <td colSpan={3} className="text-center">
                                No hay sobrante disponible para este producto
                            </td>
                        </tr>
                    )}
                    {existencias.map((existencia) => (
                        <tr key={existencia.id}>
                            <td className="text-center text-nowrap">
                                <NullableValue value={existencia.producto}>
                                    {existencia.producto &&
                                        existencia.producto.nombre}
                                </NullableValue>
                            </td>
                            <td className="text-center text-nowrap">
                                <NullableValue
                                    value={existencia.kg_disponibles}
                                >
                                    <RenderKilogramo
                                        value={existencia.kg_disponibles}
                                        decimals={3}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-center">
                                <div
                                    className="mx-auto"
                                    style={{ maxWidth: "140px" }}
                                >
                                    <NumberFormat
                                        className="form-control"
                                        value={existencia.kg_a_consumir}
                                        thousandSeparator=","
                                        allowNegative={false}
                                        isAllowed={(values) => {
                                            const { floatValue } = values;

                                            if (floatValue === undefined) {
                                                return true;
                                            }

                                            return (
                                                floatValue <=
                                                    existencia.kg_disponibles &&
                                                floatValue >= 0
                                            );
                                        }}
                                        onValueChange={(values) => {
                                            handleChange(
                                                existencia.id,
                                                values.floatValue,
                                            );
                                        }}
                                        placeholder="0"
                                        decimalScale={3}
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
